<div class="if-modal" (click)="onBackdropClick($event)">
  <div class="if-modal-backdrop" [@modalBackdrop]="animState()"></div>
  <div class="if-modal-body" [@modalBody]="animState()" (@modalBody.done)="onBodyAnimationDone($event)">
    @if (showCloseButton()) {
      <div class="if-modal-close">
        <app-button variant="black" size="icon" (click)="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </app-button>
      </div>
    }
    <ng-content select=".if-modal-title"></ng-content>
    <ng-content select=".if-modal-content"></ng-content>
    <ng-content select=".if-modal-actions"></ng-content>
  </div>
</div>
